export default __webpack_public_path__ + "static/media/saidhamlogo.bd4b218a.png";